var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "-3 -1 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.945 0 14 5.616V15.7c0 1.25-.94 2.3-2.2 2.3H2.2C.94 18 0 16.95 0 15.7V2.3C0 1.05.94 0 2.2 0h6.745ZM6 2H2.2c-.103 0-.2.108-.2.3v13.4c0 .192.097.3.2.3h9.6c.103 0 .2-.108.2-.3V7H6V2Zm4.755 3-2.7-3H8v3h2.755Z"
  })));
};
export default SvgFile;